import type { Comp, GameObj } from "kaplay";
import { emit } from "../core/events";
import type { RunState } from "../core/runState";
import type { Mountain } from "../systems/mountain";
import { gripBonusAt, type SurfaceRegion } from "../systems/surface";
import type { RiderComp } from "./rider";

export function mountainTracker(run: RunState, mountain: Mountain, regions: () => SurfaceRegion[]): Comp {
    return {
        id: "mountainTracker",
        require: ["rider"],
        update(this: GameObj<RiderComp>) {
            const { x, y } = this.motion;
            const info = mountain.zoneAt(y);
            run.progress = info.courseProgress;

            if (info.zone !== run.zone) {
                run.zone = info.zone;
                emit("zoneChange", { zone: info.zone });
            }

            if (this.isAirborne()) return;
            run.gripBonus = gripBonusAt(x, y, regions());
            const surface = mountain.surfaceAt(x, y, regions());
            if (surface !== run.surface) {
                run.surface = surface;
                emit("surfaceChange", { surface });
            }
        },
    };
}
